import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_recurring_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldClass;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  foreign_ccy: boolean;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
  t2t_other_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  t2t_other_fi_item_code: fromDatatype.VarcharDatatypeInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
  coupon_line_guid: fromDatatype.GuidDataFieldInterface;
  consignment_logic: fromDatatype.VarcharDatatypeInterface;
  membership_ext_start_date: fromDatatype.TimestampTzDatatypeInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.CurrencyCodeDataFieldInterface;
  point_start_date: fromDatatype.TimestampTzDatatypeInterface;
  point_end_date: fromDatatype.TimestampTzDatatypeInterface;
  payment_channel_name: fromDatatype.VarcharDatatypeInterface;
  parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  posting_fulfillment: fromDatatype.VarcharDatatypeInterface;
  posting_bundle: fromDatatype.VarcharDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_discount: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom_incl_tax: fromDatatype.NumericDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  multi_level_discount_json: fromDatatype.JsonDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  amount_open_balance: fromDatatype.NumericDatatypeInterface;
  amount_cogs: fromDatatype.NumericDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
  del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  delivery_option: fromDatatype.JsonDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  ready_to_ship: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
  track_delivery_table: fromDatatype.VarcharDatatypeInterface;
  track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
  track_delivery_status: fromDatatype.VarcharDatatypeInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  track_production_id: fromDatatype.VarcharDatatypeInterface;
  track_production_logic: fromDatatype.VarcharDatatypeInterface;
  track_production_table: fromDatatype.VarcharDatatypeInterface;
  track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_production_remarks: fromDatatype.VarcharDatatypeInterface;
  track_production_status: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  generated_doc_line_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_recurring_generic_doc_line_RowClass
  implements bl_fi_recurring_generic_doc_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    recurring_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    client_hashed_value: fromDatatype.VarcharDatatypeInterface;
    client_data_source: fromDatatype.VarcharDatatypeInterface;
    client_item_guid: fromDatatype.GuidDataFieldInterface;
    client_item_code: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldClass;
    base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
    foreign_ccy: boolean;
    doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
    qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    position_id: fromDatatype.VarcharDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
    t2t_other_fi_item_guid: fromDatatype.GuidDataFieldInterface;
    t2t_other_fi_item_code: fromDatatype.VarcharDatatypeInterface;
    guid_parent: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    guid_store_2: fromDatatype.GuidDataFieldInterface;
    guid_profit_center: fromDatatype.GuidDataFieldInterface;
    guid_segment: fromDatatype.GuidDataFieldInterface;
    guid_project: fromDatatype.GuidDataFieldInterface;
    guid_dimension: fromDatatype.GuidDataFieldInterface;
    guid_glcode: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_line_guid: fromDatatype.GuidDataFieldInterface;
    entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
    entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
    entity_json: fromDatatype.JsonDatatypeInterface;
    coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
    coupon_line_guid: fromDatatype.GuidDataFieldInterface;
    consignment_logic: fromDatatype.VarcharDatatypeInterface;
    membership_ext_start_date: fromDatatype.TimestampTzDatatypeInterface;
    point_type: fromDatatype.VarcharDatatypeInterface;
    point_amount: fromDatatype.NumericDatatypeInterface;
    point_currency: fromDatatype.CurrencyCodeDataFieldInterface;
    point_start_date: fromDatatype.TimestampTzDatatypeInterface;
    point_end_date: fromDatatype.TimestampTzDatatypeInterface;
    payment_channel_name: fromDatatype.VarcharDatatypeInterface;
    parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
    far_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_guid: fromDatatype.GuidDataFieldInterface;
    item_txn_type: fromDatatype.VarcharDatatypeInterface;
    item_sub_type: fromDatatype.VarcharDatatypeInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    item_machine_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.TextDatatypeInterface;
    item_desc: fromDatatype.TextDatatypeInterface;
    item_remarks: fromDatatype.TextDatatypeInterface;
    item_reference_no: fromDatatype.TextDatatypeInterface;
    item_custom_template_json: fromDatatype.JsonDatatypeInterface;
    item_custom_data_json: fromDatatype.JsonDatatypeInterface;
    item_property_json: fromDatatype.JsonDatatypeInterface;
    item_child_json: fromDatatype.JsonDatatypeInterface;
    item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
    sort_code: fromDatatype.VarcharDatatypeInterface;
    line_option_json: fromDatatype.JsonDatatypeInterface;
    line_property_json: fromDatatype.JsonDatatypeInterface;
    label_json: fromDatatype.JsonDatatypeInterface;
    serial_no: fromDatatype.JsonDatatypeInterface;
    batch_no: fromDatatype.JsonDatatypeInterface;
    bin_no: fromDatatype.JsonDatatypeInterface;
    posting_fulfillment: fromDatatype.VarcharDatatypeInterface;
    posting_bundle: fromDatatype.VarcharDatatypeInterface;
    unit_price_std: fromDatatype.NumericDatatypeInterface;
    unit_discount: fromDatatype.NumericDatatypeInterface;
    quantity_base: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
    unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_price_std_by_uom_incl_tax: fromDatatype.NumericDatatypeInterface;
    unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
    qty_by_uom: fromDatatype.NumericDatatypeInterface;
    uom_json: fromDatatype.JsonDatatypeInterface;
    unit_price_net: fromDatatype.NumericDatatypeInterface;
    amount_std: fromDatatype.NumericDatatypeInterface;
    amount_discount: fromDatatype.NumericDatatypeInterface;
    multi_level_discount_json: fromDatatype.JsonDatatypeInterface;
    amount_net: fromDatatype.NumericDatatypeInterface;
    tax_gst_code: fromDatatype.VarcharDatatypeInterface;
    tax_gst_type: fromDatatype.VarcharDatatypeInterface;
    tax_gst_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    tax_wht_type: fromDatatype.VarcharDatatypeInterface;
    tax_wht_code: fromDatatype.VarcharDatatypeInterface;
    tax_wht_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_wht: fromDatatype.NumericDatatypeInterface;
    unit_price_txn: fromDatatype.NumericDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    qty_open: fromDatatype.NumericDatatypeInterface;
    quantity_signum: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    amount_open_balance: fromDatatype.NumericDatatypeInterface;
    amount_cogs: fromDatatype.NumericDatatypeInterface;
    amount_json: fromDatatype.JsonDatatypeInterface;
    arap_pns_amount: fromDatatype.NumericDatatypeInterface;
    arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
    del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
    del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
    del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
    delivery_required: fromDatatype.VarcharDatatypeInterface;
    delivery_option: fromDatatype.JsonDatatypeInterface;
    cfg_delivery: fromDatatype.VarcharDatatypeInterface;
    cfg_production: fromDatatype.VarcharDatatypeInterface;
    ready_to_ship: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    track_delivery_guid: fromDatatype.GuidDataFieldInterface;
    track_delivery_id: fromDatatype.VarcharDatatypeInterface;
    track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
    track_delivery_table: fromDatatype.VarcharDatatypeInterface;
    track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
    track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
    track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
    track_delivery_status: fromDatatype.VarcharDatatypeInterface;
    track_production_guid: fromDatatype.GuidDataFieldInterface;
    track_production_id: fromDatatype.VarcharDatatypeInterface;
    track_production_logic: fromDatatype.VarcharDatatypeInterface;
    track_production_table: fromDatatype.VarcharDatatypeInterface;
    track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
    track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
    track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
    track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
    track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
    track_production_remarks: fromDatatype.VarcharDatatypeInterface;
    track_production_status: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    generated_doc_line_guid: fromDatatype.GuidDataFieldInterface;
}
